<template>
  <Popup
    :open="open"
    :width="102"
    :position="{ top: 45, left: -10 }"
    :zIndex="11"
  >
    <div class="popup">
      <div
        v-track
        :data-oid="OID_MAP.POPUP_SEARCH_CLASSIFY_SELECT"
        :data-ctx="item.text"
        class="cell"
        :key="key"
        v-for="(item, key) in currentClassifyCategory"
        @click="handleCellClick(item, key)"
      >
        <span class="text">
          <img
            v-if="item.isNew"
            class="icon_new"
            src="../../../assets/img/SearchBar/icon_new.png"
            alt="icon_new"
          />
          {{ item.text }}
        </span>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from "@/components/common/Popup";
import { OID_MAP } from "@/utils/constants/constants.track";

export default {
  name: "PopupSearchClassify",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OID_MAP,
    };
  },
  components: { Popup },
  computed: {
    currentClassifyCategory() {
      return this.$store.getters["search/currentClassifyCategory"];
    },
  },
  methods: {
    handleCellClick(value, index) {
      this.$emit("cell", { value, index });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/config";

.popup {
  width: 100%;
  margin-top: -10px;
  padding-top: 10px;

  .cell {
    height: 44px;
    line-height: 44px;
    padding-left: 20px;
    cursor: pointer;

    .text {
      position: relative;

      .icon_new {
        position: absolute;
        width: 24px;
        height: 12px;
        top: -9.5px;
        right: -27px;
      }
    }

    &:hover {
      background-color: $cell-hover-bg-color;
      color: $theme-color;
    }

    &:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    &:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
}
</style>
